import { Component, EventEmitter, Output } from "@angular/core";
import { UserCollectionAction } from "@apiserver-rest/ponder-data-client-base";
import { UserCollectionExportTaskStatus, UserCollectionImportTaskStatus } from "@apiserver-rest/ponder-tasks-client-base";

@Component({
    template: "",
    standalone: false
})
export class CollectionEvents {
    @Output()
    public collectionModifiedEvent: EventEmitter<CollectionModifiedEvent> = new EventEmitter();

    @Output()
    public collectionImportedEvent: EventEmitter<UserCollectionImportTaskStatus> = new EventEmitter();

    @Output()
    public collectionExportedEvent: EventEmitter<UserCollectionExportTaskStatus> = new EventEmitter();

    @Output()
    public toggledUserCollectionActionEvent: EventEmitter<UserCollectionActionToggledEvent> = new EventEmitter();

    @Output()
    public toggleUserCollectionActionDateEvent: EventEmitter<UserCollectionActionDateToggledEvent> = new EventEmitter();
}

export class CollectionModifiedEvent {
    public itemId!: string;

    public newToCollection!: boolean;
    public removedFromCollection!: boolean;

    public countAdjustment: number = 0;
    public valueAdjustment: number = 0;
    public specialCountAdjustment: number = 0;
    public specialValueAdjustment: number = 0;
    public proxyCountAdjustment: number = 0;
}

export type UserCollectionActionToggledEvent = {
    action: UserCollectionAction,
    selected: boolean
};

export type UserCollectionActionDateToggledEvent = {
    actionDate: string,
    checked: boolean
};